import React, { useEffect } from 'react';

import { NavHashLink } from 'react-router-hash-link';
import {
  Button,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { keys } from 'ramda';

import DocumentTitle from 'components/DocumentTitle';
import CellInformation from 'components/CellInformation';

import { CELL_TYPES } from 'enums';

import useRouter from 'hooks/useRouter';
import { useMembers } from 'hooks/api/useMembers';
import { useErrors } from 'hooks/useErrors';

import ContentLayout from 'layouts/ContentLayout';
import RootLayoutV2 from 'layouts/RootLayoutV2';

import { bankAccountInformationLabels } from 'presenters/BankAccountPresenter';
import { memberColumnConfig } from 'presenters/MemberShowPresenter';

import { appRoutes } from 'router/routes';

import { getStaffLinks } from 'utils/routes';

import useStyles from './useStyles';

export const Member = () => {
  const classes = useStyles();
  const { displayErrorsInToast } = useErrors();
  const {
    query: { id },
  } = useRouter();

  const { loadMember, isMemberLoading, memberTableData } = useMembers();

  const isInformationCell = key => memberColumnConfig[key]?.cellType === CELL_TYPES.information;

  const fetchData = async () => {
    try {
      await loadMember(id);
    } catch (e) {
      displayErrorsInToast([e]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const title = memberTableData?.name;

  const sideBarContent = getStaffLinks();

  return (
    <RootLayoutV2 sideBarContent={sideBarContent} isLoading={isMemberLoading}>
      <ContentLayout isSmall>
        <DocumentTitle title={title} />
        <h2 className={classes.contentSubtitle}>Members</h2>
        <div className={classes.contentPanel}>
          <Typography className={classes.contentTitle} variant="h1">
            {title}
          </Typography>
          <Button
            type="button"
            className={classes.editButton}
            variant="text"
            color="primary"
            exact
            to={appRoutes.staffMemberEditPath(id)}
            component={NavHashLink}
          >
            Edit Member
          </Button>
        </div>
        <div className={classes.tableContent}>
          <TableContainer component={Paper} classes={{ root: classes.tableContainer }}>
            <Table className={classes.table}>
              <TableBody>
                {keys(memberColumnConfig).map(key => (
                  <TableRow key={`${id}_${key}`}>
                    <TableCell className={classes.tableCell}>
                      {memberColumnConfig[key].displayedName}
                    </TableCell>
                    {isInformationCell(key) ? (
                      <TableCell className={classes.tableCell}>
                        <CellInformation
                          cellData={memberTableData[key]}
                          fieldLabels={bankAccountInformationLabels}
                        />
                      </TableCell>
                    ) : (
                      <TableCell className={classes.tableCell}>{memberTableData[key]}</TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </ContentLayout>
    </RootLayoutV2>
  );
};
